<template>
  <div class="introduce">
    <!--    <div class="introduce-banner">-->
    <!--      <h5 class="line-clamp-1">亲子互动朗读课程</h5>-->
    <!--      <p>科学依据宝宝3个月之后，就开始想和身边的人用语言进行交流了，-->
    <!--        而且还会尝试着发出连续的声音，而到了5个月的时候，就可以清-->
    <!--        楚地分辨大部分各种不同的声音，6个月左右，在熟悉的环境里，-->
    <!--        宝宝会不断地牙牙学语，向你证明，我已经“长大”了!</p>-->
    <!--    </div>-->
    <!--    <div class="introduce-Tit">从发声到演讲，更加全面的早教班</div>-->
    <!--    <div class="introduce-con publick">-->
    <!--      <li>-->
    <!--        <div class="img"><img src="./int1.png" width="65" height="65" alt=""></div>-->
    <!--        <div class="h5">发声</div>-->
    <!--        <div class="p">-->
    <!--          <p>发音器官包括三大部分：</p>-->
    <!--          <p>肺部、喉部、口部。</p>-->
    <!--          <p>发音器官又可以分为喉上器官和喉两大部分， 喉上器官由口腔、鼻腔和咽腔几个部分组成</p>-->
    <!--        </div>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--        <div class="img"><img src="./int2.png" width="65" height="65" alt=""></div>-->
    <!--        <div class="h5">互动</div>-->
    <!--        <div class="p">-->
    <!--          <p>婴儿时期的亲子互动，对宝宝的智能发展</p>-->
    <!--          <p>起着重要作用。宝宝需要学会</p>-->
    <!--          <p>对别人的行为做出正确的回应，</p>-->
    <!--          <p>比如，宝宝能对妈妈的微笑、拥抱、照顾</p>-->
    <!--          <p>等 做出声音、微笑或者其他的身体反应</p>-->
    <!--        </div>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--        <div class="img"><img src="./int3.png" width="65" height="65" alt=""></div>-->
    <!--        <div class="h5">演讲</div>-->
    <!--        <div class="p">-->
    <!--          <p>做好演讲提纲是关键的一步：</p>-->
    <!--          <p>演讲的题目、逐渐深化的论点、论据、</p>-->
    <!--          <p>结论和提议都是重要的环节</p>-->
    <!--        </div>-->
    <!--      </li>-->
    <!--    </div>-->
    <div class="publick intContent" v-html="info.detail"></div>
    <div class="indexTit"><span>公 /开 / 课</span></div>
    <div class="indexCourse">
      <ul class="publick">
        <li @click="pushcourseClick(item.id)" v-for="(item, index) in pushcourse" :key="index">
          <div class="img">
            <img :src="item.cover" width="287" height="175" alt="">
            <div class="hot">{{item.tag}}</div>
<!--            <div class="label">-->
<!--              <span v-for="(items, indexs) in item.level" :key="indexs">{{items.name}}</span>-->
<!--            </div>-->
          </div>
          <div class="describe line-clamp-2">{{item.title}}</div>
          <div class="dykc">{{item.ffjz_course}}</div>
          <div class="num">
            <div class="people fl"><img src="./people.png" width="18" height="12" alt="">{{item.study_num}}</div>
            <div class="comment fl"><img src="./comment.png" width="14" height="13" alt="">{{item.log_num}}</div>
            <div class="price fr">￥{{item.price}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      pushcourse: {
        type: Array,
        default: () => {
        }
      },
      info: {
        type: Object,
        default: () => {
        }
      }
    },
    data () {
      return {}
    },
    created () {

    },
    methods: {
      pushcourseClick (id) {
        this.$parent.id = id
        this.$parent.getData()
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .introduce {
    .introduce-banner {
      width: 1200px;
      height: 450px;
      background: url("./intBanner.png") no-repeat center center;
      margin: 0 auto;
      color: #fff;
      overflow: hidden;

      h5 {
        width: 600px;
        font-size: 30px;
        margin: 100px 0 0 130px;
        font-weight: normal;
      }

      p {
        width: 600px;
        line-height: 30px;
        height: 150px;
        margin: 50px 0 0 130px;
        font-weight: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
      }
    }

    .introduce-Tit {
      font-size: 40px;
      margin: 100px auto;
      text-align: center;
    }

    .introduce-con {
      overflow: hidden;

      li {
        width: 315px;
        overflow: hidden;
        float: left;
        margin: 0px 42.5px 0px;

        .img {
          width: 65px;
          height: 65px;
          margin: 0 auto;
        }

        .h5 {
          font-size: 24px;
          margin: 30px auto 0;
          text-align: center;
          color: #535353;
        }

        .p {
          line-height: 30px;
          height: 150px;
          overflow: hidden;
          margin: 30px auto 0;

          p {
            text-align: center;
          }
        }
      }
    }

    .intContent {
      margin: 0px auto;
      overflow: hidden;
      font-size: 16px;
      line-height: 30px;

      img {
        margin: 20px auto;
      }

    }

    .indexTit {
      width: 100%;
      height: 80px;
      line-height: 80px;
      font-size: 30px;
      color: #5c5c5c;
      text-align: center;
      margin: 100px auto 0;

      span {
        background: url("./titBg.png") no-repeat right top;
        padding: 20px 28px;
      }

    }

    .indexCourse {
      width: 100%;
      overflow: hidden;
      box-shadow: 0px 20px 20px -20px #f5f5f5;
      padding-bottom: 80px;
      margin-bottom: 50px;

      li {
        width: 287px;
        overflow: hidden;
        float: left;
        margin: 50px 17.3px 0 0;
        cursor: pointer;

        .dykc {
          margin: 10px auto;
          color: #8f8f8f;
        }

        &:nth-child(4n) {
          margin-right: 0;
        }

        .img {
          width: 287px;
          height: 175px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          .hot {
            position: absolute;
            width: 50px;
            height: 35px;
            border-radius: 0 17.5px 17.5px 0;
            background-color: #fff;
            text-align: center;
            line-height: 35px;
            color: #fc8375;
            font-size: 14px;
            font-weight: bold;
            left: 0;
            top: 20px;
          }

          .label {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 20px;

            span {
              background-color: rgba(0, 0, 0, 0.5);
              color: #fff;
              padding: 5px 8px;
              border-radius: 10px;
              margin: 0 0 0 10px;
              line-height: 35px;
            }
          }
        }

        .describe {
          width: 287px;
          max-height: 40px;
          line-height: 20px;
          margin-top: 15px;
        }

        .num {
          height: 20px;
          width: 100%;
          font-size: 12px;
          color: #8f8f8f;
          margin-top: 10px;

          img {
            display: block;
            float: left;
          }

          .people {
            line-height: 20px;
            margin-right: 20px;

            img {
              margin: 3px 5px 0 0;
            }
          }

          .comment {
            line-height: 20px;

            img {
              margin: 5px 5px 0 0;
            }
          }

          .price{
            color: #ff8484;
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseDetails/introduce/introduce.vue